import { FC, useEffect, useRef } from 'react';

import { company } from '~/company/Company';
import ProductsCarouselSliderOneBlockSkeleton from '~/components/CategoryBlocks/ProductsCarouselSliderOneBlock/ProductsCarouselSliderOneBlockSkeleton';
import { ProductsCarouselSliderOneBlockSkeleton as ProductsCarouselSliderOneBlockSkeletonV3 } from '~/components/isolated/CategoryBlocks/ProductsCarouselSliderOneBlock';

interface ScrollPaginationSkeletonProps {
  onLoadMore(): void;
  className?: string;
}

/**
 * Helper function to select the appropriate skeleton version based on company config
 * Returns V3 version if newDesignSystemEnabled is true, otherwise returns legacy version
 */
const getSkeletonVersion = <T,>(legacySkeleton: T, v3Skeleton: T): T => {
  if (company.newDesignSystemEnabled) {
    return v3Skeleton;
  }
  return legacySkeleton;
};

export const ScrollPaginationSkeleton: FC<ScrollPaginationSkeletonProps> = ({
  onLoadMore,
  className,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            onLoadMore();
          }
        });
      },
      { rootMargin: `${window.innerHeight}px` },
    );

    // FIXME
    setTimeout(() => {
      ref.current && observer.observe(ref.current);
    }, 2000);

    return () => observer.disconnect();
  }, [onLoadMore]);

  const ProductsCarouselSkeleton = getSkeletonVersion(
    ProductsCarouselSliderOneBlockSkeleton,
    ProductsCarouselSliderOneBlockSkeletonV3,
  );

  return <ProductsCarouselSkeleton ref={ref} className={className} />;
};
